import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'

import * as statisticalStore from '@/store/statistical'

export {
  statisticalStore
}

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createStatisticalMixin = (without = []) => {
  const actions = !without.includes('actions') ? mapActions(statisticalStore.moduleName, Object.keys(statisticalStore.actionTypes)) : {}
  const getters = !without.includes('getters') ? mapGetters(statisticalStore.moduleName, Object.keys(statisticalStore.getterTypes)) : {}
  const mutations = !without.includes('mutations') ? mapMutations(statisticalStore.moduleName, Object.keys(statisticalStore.mutationTypes)) : {}

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  }
}
